import React from "react";
import { useParams } from "react-router-dom";
import LandingPage from "../LandingPage/LandingPage";

const TrackingPage = () => {
  const { tripId } = useParams();
  return <LandingPage dedicatedTripId={tripId} />;
};

export default TrackingPage;
